import { main } from "./_client/main";

main();
